module.exports = __webpack_public_path__ + "static/media/moreresult.75b57b7.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/moreresult.mp4
// module id = iKC+
// module chunks = 0